import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  PixelRatio,
  Image,
  TextInput,
  ActivityIndicator,
  Modal,
  Platform,
  KeyboardAvoidingView,
  ScrollView,
} from "react-native";
import React, { useContext, useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import * as AuthSession from "expo-auth-session";
import * as Google from "expo-auth-session/providers/google";
import meezalogo from "../../../assets/me_red.png"; //meeza_icon
//import meezalogo from "../../../assets/meeza_icon.png";
import * as WebBrowser from "expo-web-browser";
import * as AppleAuthentication from "expo-apple-authentication";
import AppContext from "../../context/AppContext";
import useAuth from "../../hooks/useAuth";
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons";
import { useNavigation, useRoute } from "@react-navigation/native";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import axios, { axiosWithCredentials } from "../../api/axios";

WebBrowser.maybeCompleteAuthSession();

const { width, height } = Dimensions.get("window");

const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const GoogleSign = () => {
  const [userInfo, setUserInfo] = useState(null);
  const { setAuth, setGoogleOnboardData } = useContext(AppContext);
  // const { setGoogleOnboardData } = useContext(AppContext);

  const navigation = useNavigation();
  const route = useRoute();

  const { mode, userstats } = route.params || {};

  // const { isGuest, phoneNumber, username } = useAuth();

  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [isLoadingOTP, setIsLoadingOTP] = useState(false);
  const [hasTypoError, setHasTypoError] = useState(false);
  const [isAuthLoading, setIsAuthLoading] = useState(false);

  // Computed state evaluator variables
  //const isPhoneInputReady = whatsappNumber.trim().length >= 10 && !hasTypoError;
  const isPhoneInputReady = false;

  const handleNumberValidation = (text) => {
    // Sanitizes inputs to prevent alphanumeric parsing failures
    const numericRegex = /^[0-9]*$/;
    if (numericRegex.test(text) || text === "") {
      setHasTypoError(false);
      setWhatsappNumber(text);
    } else {
      setHasTypoError(true);
    }
  };

  // const handleEmailSignup_Login = () => {
  //   // Navigate along your custom authentication tree pathways
  //   navigation.navigate("sign_ups");
  // };

  const redirectUri = AuthSession.makeRedirectUri({
    native: "meeza",
  });

  //console.log("redirectUri", redirectUri);

  const [request, response, promptAsync] = Google.useAuthRequest({
    // 1. For Expo Go or Web testing
    // webClientId: "607742650924-4qvotvu1q75g3a9dchind088c87pmpco.apps.googleusercontent.com",
    webClientId: "607742650924-2ei9go2bl635sl9gh1pakdj2rqr3s0kn.apps.googleusercontent.com",

    // 2. For your physical iPhone build
    iosClientId: "607742650924-mbcms1rms9i91dj5l9cdp4143lgua83c.apps.googleusercontent.com",

    // 3. For your Android build
    androidClientId: "607742650924-k779l559pl0hjfse5a2kch7cqh5j71jf.apps.googleusercontent.com",

    // redirectUri: Platform.OS === "web" ? "https://app.getmeeza.com" : undefined,
    // redirectUri: Platform.OS === "web" ? "http://localhost:8081/" : undefined,
    redirectUri: AuthSession.makeRedirectUri({
      scheme: "http",
      // host: '127.0.0.1', // Swap from localhost to loopback IP
      host: "localhost", // Swap from localhost to loopback IP
      port: 8081,
      path: "", // Explicitly forces NO trailing slash
    }),
  });

  useEffect(() => {
    if (response?.type === "success") {
      const { authentication } = response;
      const { accessToken } = authentication;

      sendGoogleTokenToBackend(accessToken);
    }
  }, [response]);

  const sendGoogleTokenToBackend = async (token) => {
    try {
      setIsAuthLoading(true);
      // Axios automatically parses incoming JSON and throws errors for non-2xx status codes
      const response = await axiosWithCredentials.post("/googleAuth/googleAuth", {
        token: token,
      });

      const data = response.data;
      console.log("RESPOSEEE GOOGLE0", response, data);

      if (data.success) {
        // setAuth({ accessToken: data.accessToken });
        setAuth({
          accessToken: data.accessToken,
          isProfileComplete: data.isProfileComplete,
        });

        switch (data.action) {
          case "NAVIGATE_TO_ONBOARDING":
            console.log("setup profile - onboard");

            console.log("data.action", data.action, data.message);

            // 💾 Save the full backend response directly into global memory
            setGoogleOnboardData({
              username: data.username || "guest_",
              firstname: data.firstname || data.suggestedName?.split(" ")[0] || "",
              lastname: data.lastname || data.suggestedName?.split(" ")[1] || "",
              email: data.email || "",
              profilePicture: data.suggestedAvatar || "",
              isGoogleAuth: true,
            });

            // 🚀 Safely navigate using JUST the param your linking config expects
            navigation.navigate("user_identity", { userId: data.userId });
            break;

          case "NAVIGATE_TO_PROFILE_SETUP":
            console.log("setup profile");

            // User exists but has an active "guest_" username status framework flag
            navigation.navigate("EditProfileScreen", {
              userId: data.userId,
              isGuestUpgrade: true,
            });
            break;

          case "NAVIGATE_TO_HOME":
            console.log("home");
            // setAuth({ accessToken: data.accessToken });
            // Standard verified account profile setup — skip directly to core screens
            // Handle saving your application's JWT session token tokens here
            // navigation.navigate("main");
            // navigation.navigate("Home");
            break;

          default:
            console.warn("Unexpected routing execution action received:", data.action);
        }
      }
    } catch (error) {
      // Catch-all structural error logging block
      if (error.response) {
        // The server responded with a status code outside the 2xx range
        console.error("Backend Error Data:", error.response.data);
      } else if (error.request) {
        // The request was made but no response was received (Network issues)
        console.error("Network Connectivity Timeout:", error.request);
      } else {
        console.error("Axios Runtime Config Error:", error.message);
      }
    } finally {
      setIsAuthLoading(false);
    }
  };

  const handleApplePWALogin = () => {
    try {
      setIsAuthLoading(true);
      console.log("Handlings");
      if (Platform.OS === "web") {
        // 1. Identify your registered Web configurations
        // const clientId = "com.mexxa.pwa"; // e.g., com.mixrapp.auth
        const clientId = "com.mexxzia.pwa"; // e.g., com.mixrapp.auth
        const redirectUri = "https://getmeeza.com/prollix/appleAuth/appleAuth";

        const scope = "name email";
        const responseType = "code id_token";
        const responseMode = "form_post"; // Apple strictly mandates form_post for id_token responses on web
        const state = "mezzar_auth_apple"; // Helps prevent CSRF attacks

        // 2. Assemble the target Apple OAuth 2 URL
        const appleAuthUrl =
          `https://appleid.apple.com/auth/authorize` +
          `?client_id=${clientId}` +
          `&redirect_uri=${encodeURIComponent(redirectUri)}` +
          `&response_type=${encodeURIComponent(responseType)}` +
          `&response_mode=${responseMode}` +
          `&state=${state}` +
          `&scope=${encodeURIComponent(scope)}`;

        // 3. Bounce the user to Apple's interface
        window.location.href = appleAuthUrl;
      }
    } catch (error) {
      setIsAuthLoading(false);
      // Catch-all structural error logging block
      if (error.response) {
        // The server responded with a status code outside the 2xx range
        console.error("Backend Error Data:", error.response.data);
      } else if (error.request) {
        // The request was made but no response was received (Network issues)
        console.error("Network Connectivity Timeout:", error.request);
      } else {
        console.error("Axios Runtime Config Error:", error.message);
      }
    }
    // finally {
    //   setIsAuthLoading(false);
    // }
  };

  const handleGoogleAuth = () => {
    //console.log("Google Sign In");
  };

  const handleProceed = async () => {
    // 1. Remove everything that isn't a number (removes spaces, +, dashes)
    let cleaned = whatsappNumber.replace(/\D/g, "");

    // 2. Remove ANY number of leading zeros (0, 00, 000...)
    cleaned = cleaned.replace(/^0+/, "");

    // 3. Remove leading 234 if it's now at the front
    if (cleaned.startsWith("234")) {
      cleaned = cleaned.slice(3);
    }

    // 4. Remove leading zero AGAIN (in case it was 234081...)
    cleaned = cleaned.replace(/^0+/, "");

    // Validation check
    if (cleaned.length !== 10) {
      // Show error...
      //console.log("number error");
      setErrorMessage("You might have entered a wrong number");
      setIsErrorCompVisible(true);
      return;
    }

    // 3. Final standardized format
    const finalPhoneNumber = `234${cleaned}`;

    //console.log("Input:", whatsappNumber);
    //console.log("Cleaned (local):", cleaned);
    //console.log("Final (International):", finalPhoneNumber);

    //return;

    //  const finalPhoneNumber = `234${formattedNumber}`;

    // 3. Send to Backend
    try {
      setIsLoadingOTP(true);
      const response = await axios.post("/phoneSearch/phoneSearch", {
        phoneNumber: finalPhoneNumber,
      });

      // Handle your backend 'action' responses (NAVIGATE_TO_LOGIN, etc.)
      handleBackendResponse(response.data);
    } catch (error) {
      console.error("Error searching phone:", error);
    } finally {
      setIsLoadingOTP(false);
    }
  };
  const handleProceed1 = () => {
    setErrorMessage("Not available at the moment, continue with Google or Apple");
    setIsErrorCompVisible(true);
  };

  const handleBackendResponse = (data) => {
    const { success, action, message, phoneNumber, isNewUser } = data;
    //console.log(success, action, "NewUser", isNewUser);

    switch (action) {
      case "VERIFY_OTP":
        // The "Anonymized" user path: code sent to WhatsApp
        // Move to the OTP input screen
        //console.log("Hereerer");
        navigation.navigate("otp_page", {
          whatsappNumber: phoneNumber,
          mode: "userSearch",
        });
        break;

      case "NAVIGATE_TO_LOGIN":
        // Full account exists (Email + Password)
        // Move to the password input screen
        //console.log("full here");

        // navigation.navigate("log_in", {
        //   phoneNumber: phoneNumber,
        // });
        navigation.navigate("log_in", {
          mode: "complete_user",
          phoneNumber: phoneNumber,
        });
        break;

      case "NAVIGATE_TO_SIGNUP":
        // No user found at all
        // Move to the initial signup/onboarding screen
        //console.log("test here");

        navigation.navigate("sign_up", {
          phoneNumber: phoneNumber,
        });

        break;

      default:
        // Fallback for unexpected actions or errors
        setIsErrorCompVisible(true);
        setErrorMessage(message || "Something went wrong. Please try again.");
        break;
    }
  };

  if (isAuthLoading) {
    return (
      <View style={[styles.container]}>
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
      </View>
    );
  }

  return (
    <KeyboardAvoidingView
      style={styles.container}
      behavior={Platform.OS === "ios" ? "padding" : "height"}
    >
      <ScrollView
        contentContainerStyle={styles.scrollContent}
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
      >
        {/* ================= HEADER BRAND ZONE ================= */}
        <View style={styles.logoWrapper}>
          <Image source={meezalogo} style={styles.logoImage} />
        </View>

        <Text style={styles.title}>Welcome</Text>
        <Text style={styles.appNameSubtitle}>to Meeza - the doings app</Text>
        <Text style={styles.subtitle}>Continue to start your Meeza experience</Text>

        {/* ================= OAUTH SSO CONFIG MATRIX ================= */}
        <View style={styles.oauthStack}>
          {/* Google Authentication Button */}
          <TouchableOpacity
            disabled={isAuthLoading}
            style={[styles.googleButton, isAuthLoading && { opacity: 0.6 }]}
            onPress={() => promptAsync({ useProxy: true })}
          >
            <Image
              source={{
                uri: "https://developers.google.com/identity/images/g-logo.png",
              }}
              style={styles.googleIcon}
            />
            <Text style={styles.googleText}>
              {mode === "complete_user" ? "Login with Google" : "Continue with Google"}
            </Text>
          </TouchableOpacity>

          {/* Apple Authentication Button */}
          <TouchableOpacity
            disabled={isAuthLoading}
            style={[styles.appleButton, isAuthLoading && { opacity: 0.6 }]}
            onPress={() => {
              /* Trigger Native Apple Sign-In */
              handleApplePWALogin();
            }}
          >
            <Ionicons name="logo-apple" size={20} color="white" />
            <Text style={styles.appleText}>Continue with Apple</Text>
          </TouchableOpacity>
        </View>

        {/* ================= INTERSECTION DIVIDER ================= */}
        <View style={styles.dividerContainer}>
          <View style={styles.dividerLine} />
          <Text style={styles.dividerText}>OR USE WHATSAPP</Text>
          <View style={styles.dividerLine} />
        </View>

        {/* ================= WHATSAPP NUMERIC TUNNEL ================= */}
        <Text style={styles.inputFieldLabel}>Enter WhatsApp Number</Text>
        <View
          style={[
            styles.inputContainer,
            hasTypoError && styles.inputErrorBorder,
            isPhoneInputReady && styles.inputActiveBorder,
          ]}
        >
          <Ionicons
            name="logo-whatsapp"
            size={22}
            color={hasTypoError ? "#FF3B30" : isPhoneInputReady ? "#25D366" : "#8E8E93"}
            style={styles.inputIconSpacer}
          />
          <TextInput
            style={[styles.textInputLayer, hasTypoError && styles.errorTextColour]}
            placeholder="e.g. 08030000000"
            placeholderTextColor="#A8A8A8"
            keyboardType="phone-pad"
            value={whatsappNumber}
            onChangeText={handleNumberValidation}
          />
        </View>

        {/* Input Typo Helper Warning Badge */}
        {hasTypoError && (
          <Text style={styles.errorTextBadge}>
            Please enter numbers only. Letters are not allowed.
          </Text>
        )}

        {/* Verification OTP Trigger Route Trigger */}
        <TouchableOpacity
          // disabled={!isPhoneInputReady}
          style={[
            styles.otpSubmitButton,
            isPhoneInputReady ? styles.otpActiveBackground : styles.otpInactiveBackground,
          ]}
          onPress={handleProceed}
          // onPress={async () => {
          //   if (!isPhoneInputReady) return;
          //   try {
          //     setIsLoadingOTP(true);
          //     const response = await axios.post("/requestOtp/requestOtp", {
          //       phoneNumber: whatsappNumber,
          //     });

          //     if (response.status === 200 || response.status === 201) {
          //       navigation.navigate("otp_page", {
          //         whatsappNumber: whatsappNumber,
          //         // tableId,
          //         mode: "fromOnboarding",
          //       });
          //     }
          //   } catch (error) {
          //     console.error("OTP Transmission Exception Failure Handler Context:", error);
          //   } finally {
          //     setIsLoadingOTP(false);
          //   }
          // }}
        >
          {isLoadingOTP ? (
            <ActivityIndicator size="small" color="white" />
          ) : (
            <Text style={styles.otpSubmitText}>Get OTP Code</Text>
          )}
        </TouchableOpacity>
      </ScrollView>

      {/* ================= MANUAL EMAIL ACCOUNT ALT ROUTE ================= */}
      {/* <TouchableOpacity style={styles.emailAltButton} onPress={handleEmailSignup_Login}>
        <MaterialCommunityIcons
          name="email-outline"
          size={20}
          color={Colours.PRIMARY}
          style={styles.emailIconSpacer}
        />
        <Text style={styles.emailAltText}>
          {mode === "complete_user" ? "Login with email or username" : "Continue with Email"}
        </Text>
      </TouchableOpacity> */}
      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
    </KeyboardAvoidingView>
  );
};

// ================= STRUCTURAL LAYOUT STYLESHEET =================
const styles = StyleSheet.create({
  // container: {
  //   flex: 1,
  //   backgroundColor: "#ffffff",
  //   justifyContent: "center",
  //   paddingHorizontal: dynamicSpacing(30),
  // },
  container: {
    flex: 1,
    backgroundColor: "#ffffff",
    paddingTop: dynamicSpacing(30),
  },
  scrollContent: {
    flexGrow: 1,
    justifyContent: "center",
    paddingHorizontal: dynamicSpacing(30),
    paddingVertical: dynamicSpacing(20),
  },
  logoWrapper: {
    width: dynamicSize(70),
    height: dynamicSize(70),
    borderRadius: dynamicSize(15),
    overflow: "hidden",
    marginBottom: dynamicSpacing(20),
  },
  logoImage: {
    width: "100%",
    height: "100%",
  },
  title: {
    fontSize: dynamicFontSize(34),
    fontWeight: "700",
    color: "#1A1A1A",
  },
  appNameSubtitle: {
    fontSize: dynamicFontSize(20),
    fontFamily: "Sen-Bold",
    color: "#1A1A1A",
    marginTop: dynamicSpacing(2),
    marginBottom: dynamicSpacing(4),
  },
  subtitle: {
    fontSize: dynamicFontSize(14),
    color: "#777",
    marginBottom: dynamicSpacing(32),
  },
  oauthStack: {
    gap: dynamicSpacing(12),
    marginBottom: dynamicSpacing(16),
  },
  googleButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: "#E6E6E6",
    paddingVertical: dynamicSpacing(16),
    borderRadius: dynamicSize(12),
    backgroundColor: "#fff",
  },
  googleIcon: {
    width: dynamicSize(20),
    height: dynamicSize(20),
    marginRight: dynamicSpacing(12),
  },
  googleText: {
    fontSize: dynamicFontSize(15),
    fontWeight: "600",
    color: "#1A1A1A",
  },
  appleButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    backgroundColor: "#000",
    borderRadius: dynamicSize(12),
    paddingVertical: dynamicSpacing(16),
  },
  appleText: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(15),
    color: "white",
  },

  dividerContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: dynamicSpacing(24),
  },
  dividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: "#EAEAEA",
  },
  dividerText: {
    paddingHorizontal: 12,
    color: "#8E8E93",
    fontSize: dynamicFontSize(12),
    fontWeight: "600",
  },
  inputFieldLabel: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(14),
    color: "#333",
    marginBottom: dynamicSpacing(8),
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#E5E5EA",
    borderRadius: dynamicSize(12),
    paddingHorizontal: 14,
    backgroundColor: "#F9F9FA",
    height: dynamicSize(54),
    marginBottom: dynamicSpacing(16),
  },
  inputErrorBorder: {
    borderColor: "#FF3B30",
  },
  inputActiveBorder: {
    borderColor: Colours.PRIMARY,
  },
  inputIconSpacer: {
    marginRight: 10,
  },
  textInputLayer: {
    flex: 1,
    height: "100%",
    fontSize: dynamicFontSize(15),
    color: "#1A1A1A",
  },
  errorTextColour: {
    color: "#FF3B30",
  },
  errorTextBadge: {
    color: "#FF3B30",
    fontSize: dynamicFontSize(12),
    marginTop: dynamicSpacing(-10),
    marginBottom: dynamicSpacing(16),
    marginLeft: 5,
  },
  otpSubmitButton: {
    borderRadius: dynamicSize(12),
    paddingVertical: dynamicSpacing(16),
    alignItems: "center",
    justifyContent: "center",
    height: dynamicSize(55),
    marginBottom: dynamicSpacing(20),
  },
  otpActiveBackground: {
    backgroundColor: Colours.PRIMARY,
    shadowColor: Colours.PRIMARY,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 6,
    elevation: 4,
  },
  otpInactiveBackground: {
    backgroundColor: "#E5E5EA",
    elevation: 0,
  },
  otpSubmitText: {
    fontFamily: "Sen-Bold",
    color: "white",
    fontSize: dynamicFontSize(16),
  },
  emailAltButton: {
    height: dynamicSize(55),
    borderRadius: dynamicSize(12),
    borderWidth: 1,
    borderColor: Colours.PRIMARY,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    backgroundColor: "transparent",
  },
  emailIconSpacer: {
    marginRight: 10,
  },
  emailAltText: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
  },
});

export default GoogleSign;
